import { createActions } from 'redux-actions';
import { create } from '../../services';

const {
  repairInspectionReportCreateRequest,
  repairInspectionReportCreateSuccess,
  repairInspectionReportCreateFailure,
} = createActions({
  REPAIR_INSPECTION_REPORT_CREATE_SUCCESS: json => json,
}, 'REPAIR_INSPECTION_REPORT_CREATE_REQUEST', 'REPAIR_INSPECTION_REPORT_CREATE_FAILURE');

export function repairInspectionReportCreate(repairInspectionReportData) {
  return (dispatch) => {
    dispatch(repairInspectionReportCreateRequest());
    return create('repair_inspection_report', repairInspectionReportData)
      .then(({ json }) => dispatch(repairInspectionReportCreateSuccess(json)))
      .catch(error => dispatch(repairInspectionReportCreateFailure(error)));
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/repair_inspection_report.js